<template>
  <section id="section-secondary" class="section-secondary">
    <h3 :class="align">{{headline}}</h3>
    <p :class="align">
      <slot name="lead" ></slot>
    </p>
    <div class="contents" :class="columns" >
      <slot name="contents"></slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SectionSecondary',
  props: {
    headline: {
      type: String,
      default: 'タイトル'
    },
    columns: {
      type: String,
      default: 'one-column'
    },
    text: {
      type: String,
      default: '説明テキスト'
    },
    align: {
      type: String,
      default: 'center'
    }
  }
}
</script>

<style scoped>
h3 {
  font-size: var(--jumbo-font-size);
  font-weight: var(--bold-font-weight);
  line-height: 1.5;
  margin-bottom: 3.2rem;
}
p {
  font-size: var(--normal-font-size);
  line-height: 2.5;
  margin-bottom: 4.8rem;
}

.section-secondary {
  margin: 0 auto;
  padding: 9.6rem 7.2rem 6.4rem;
  box-sizing: border-box;
  border-bottom: 0.2rem solid var(--white);
}

.contents.two-columns {
  display: grid;
  grid-template-columns: repeat(auto-fill,minmax(42rem, 1fr));
  column-gap: 3.2rem;
}

.center {
  text-align: center;
}

.left {
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/SectionSecondary.vue